import generatePicker from 'antd/es/date-picker/generatePicker';
import type { Dayjs } from 'antd/node_modules/dayjs';
import dayjsGenerateConfig from 'antd/node_modules/rc-picker/lib/generate/dayjs';

const DayjsDatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default DayjsDatePicker;
